import React from "react";
import  Home from "../assets/icons/footerIcons/AdminHome.svg";
import  Loyalty  from "../assets/icons/footerIcons/loyalty.svg";
import  Rate  from "../assets/icons/footerIcons/rate.svg";
import  profile  from "../assets/icons/footerIcons/profile.svg";
import { Link } from "react-router-dom";
import Billing from "../../src/assets/icons/sidebarIcons/billing.svg"
import Stock from "../assets/icons/sidebarIcons/stock.svg"

const AdminFooter = () => {
  return (
    <nav className="fixed bottom-0 w-full bg-white border-t border-gray-300">
      <div className="flex justify-around items-center py-2">
        {/* Home */}
        <div className="flex flex-col items-center">
        <Link to="/admin-dashboard" className="flex flex-col items-center justify-center">
          <img  src={Home} size={24} className="text-gray-700 w-6 h-6 mb-1" />
          <span className="text-sm text-gray-700">Home</span>
          </Link>
        </div>

        {/* Rate */}
        <div className="flex flex-col items-center">
        <Link to="/admin-billing" className="flex flex-col items-center justify-center">
          <img src={Billing} size={24} className="text-gray-700" />
          <span className="text-sm text-gray-700">Billing</span>
        </Link>
        </div>

        {/* Loyalty */}
        <div className="flex flex-col items-center">
        <Link to="/stocks" className="flex flex-col items-center justify-center">
          <img src={Stock} size={24} className="text-gray-700 w-8 h-8" />
          <span className="text-sm text-gray-700">Stock</span>
          </Link>
        </div>

        {/* Profile */}
        <div className="flex flex-col items-center justify-center">
        <Link to="/Admin-profile" className="flex flex-col items-center justify-center">
          <img src={profile} alt="Profile Icon" className="w-6 h-6 mb-1" />
          <span className="text-sm text-gray-700">Profile</span>
        </Link>
      </div>
      </div>
    </nav>
  );
  
};

export default AdminFooter;
